import React from "react";
import { FilterSection, Listing } from "Sections/SearchRoutes";
import { FormProvider } from "components/hook-form";
import { useForm } from "react-hook-form";

function SearchPage() {
  const methods = useForm({
    defaultValues: {
      emirate: "",
      area: "",
    },
  });

  return (
    <FormProvider methods={methods}>
      <FilterSection />
      <Listing />
    </FormProvider>
  );
}

export default SearchPage;
